<div class="gift-container">
  @if (isSelected) {
    <div class="selected-box" [ngStyle]="selectedBoxStyle"></div>
  }

  <div class="right-top-item">
    @if (mode === 'profile' && gift.count) {
      <div class="count">&times;{{ gift.count }}</div>
    }
    @if (mode === 'shop' && gift.price) {
      <div>
        <app-user-economy [amount]="gift.price"></app-user-economy>
      </div>
    }
  </div>

  <div class="image-container" [ngStyle]="imageStyle">
    <img [src]="src" [alt]="gift.description" />
  </div>
  <div class="name" [ngStyle]="primaryBackgroundStyle">{{ gift.name }}</div>
</div>
